import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { ageCategories } from "../mock";

const NAVY = "#1B1F5C";

const SectionTitle = ({ children }) => (
  <div className="flex flex-col items-center mb-8">
    <h2 className="font-display font-extrabold text-2xl md:text-[32px]" style={{ color: NAVY }}>{children}</h2>
    <span className="mt-2 h-1 w-16 rounded-full" style={{ backgroundColor: "#35C3C1" }} />
  </div>
);

const ShopByAge = () => {
  const rowRef = useRef(null);
  const scrollRight = () => rowRef.current?.scrollBy({ left: 260, behavior: "smooth" });

  return (
    <section className="py-10 md:py-14 bg-white relative overflow-hidden">
      {/* doodle stars */}
      <svg className="absolute top-12 left-8 w-5 h-5 text-[#F79433] hidden md:block" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>
      <svg className="absolute bottom-10 right-10 w-6 h-6 text-[#35C3C1] hidden md:block" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>

      <div className="max-w-7xl mx-auto px-4 relative">
        <SectionTitle>Shop by Age</SectionTitle>
        <div className="relative">
          <div ref={rowRef} className="flex gap-7 md:gap-12 lg:gap-16 overflow-x-auto no-scrollbar justify-start lg:justify-center pb-2 px-1">
            {ageCategories.map((cat) => (
              <Link to={`/shop-by-age?age=${encodeURIComponent(cat.label)}`} key={cat.label} className="flex flex-col items-center shrink-0 group" data-testid={`home-age-${cat.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <span className="block h-28 w-28 md:h-36 md:w-36 lg:h-40 lg:w-40 rounded-full group-hover:-translate-y-1.5 group-hover:scale-[1.04] transition-transform duration-300">
                  <img
                    src={cat.image}
                    alt={`Toys for ${cat.label}`}
                    className="h-full w-full object-contain drop-shadow-sm group-hover:drop-shadow-xl transition-[filter] duration-300"
                    loading="lazy"
                  />
                </span>
                <span className="mt-3.5 font-display text-[14px] md:text-[15.5px] font-extrabold group-hover:text-[#35C3C1] transition-colors" style={{ color: NAVY }}>
                  {cat.label}
                </span>
              </Link>
            ))}
          </div>
          <button
            onClick={scrollRight}
            className="absolute -right-2 top-[40%] -translate-y-1/2 h-10 w-10 rounded-full bg-white shadow-lg border border-gray-100 flex items-center justify-center hover:scale-110 transition-transform lg:hidden"
            style={{ color: NAVY }}
            aria-label="Scroll categories"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export { SectionTitle };
export default ShopByAge;
